export default {
      id: "oc-icon_tenant-usage",
      viewBox: "0 0 150 150",
      url: __webpack_public_path__ + "sprite.svg#oc-icon_tenant",
      toString: function () {
        return this.url;
      }
    }